class CollectionNavigation {
  constructor() {
    this.nav = document.querySelector('.collection-nav');
    this.navLinks = document.querySelectorAll('.collection-nav__item');
    this.lastScrollTop = 0;
    this.hasScrolledPast = false;
    this.headerOffset = 62;
    this.sections = Array.from(document.querySelectorAll('.collection-block'));
    this.currentSection = null;
    this.isInitialLoad = true; // Add flag to track initial load

    this.init();
  }

  init() {
    this.setupEventListeners();
    this.updateActiveSection();
    // Set flag to false after initial setup
    setTimeout(() => {
      this.isInitialLoad = false;
    }, 100);
  }

  setupEventListeners() {
    this.setupScrollListener();
    this.setupNavLinks();
  }

  setupScrollListener() {
    window.addEventListener('scroll', () => {
      this.handleScroll();
      this.updateActiveSection();
    });
  }

  setupNavLinks() {
    this.navLinks.forEach(button => {
      button.addEventListener('click', (e) => this.handleNavClick(e));
      button.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.handleNavClick(e);
        }
      });
    });
  }

  handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const navBottom = this.nav.offsetTop + this.nav.offsetHeight;

    this.updateScrollPastState(scrollTop, navBottom);
    this.updateScrollDirection(scrollTop);
    
    this.lastScrollTop = scrollTop;
  }

  updateScrollPastState(scrollTop, navBottom) {
    if (scrollTop > navBottom) {
      this.hasScrolledPast = true;
      this.nav.classList.add('has-scrolled-past');
    } else {
      this.hasScrolledPast = false;
      this.nav.classList.remove('has-scrolled-past');
    }
  }

  updateScrollDirection(scrollTop) {
    if (scrollTop > this.lastScrollTop) {
      this.nav.classList.add('scrolling-down');
      this.nav.classList.remove('scrolling-up');
    } else {
      this.nav.classList.add('scrolling-up');
      this.nav.classList.remove('scrolling-down');
    }
  }

  updateActiveSection() {
    const scrollPosition = window.scrollY + this.headerOffset + 100;

    let currentSection = null;
    let minDistance = Infinity;

    this.sections.forEach(section => {
      const sectionTop = section.offsetTop;
      const sectionBottom = sectionTop + section.offsetHeight;
      const distance = Math.abs(scrollPosition - sectionTop);

      if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
        currentSection = section;
      }
      else if (!currentSection && scrollPosition < sectionTop && distance < minDistance) {
        currentSection = section;
        minDistance = distance;
      }
    });

    if (currentSection !== this.currentSection) {
      this.currentSection = currentSection;
      this.updateActiveLink();
    }
  }

  updateActiveLink() {
    this.navLinks.forEach(button => {
      const isActive = button.getAttribute('data-target') === `#${this.currentSection.id}`;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive);
      if (isActive && window.innerWidth <= 749 && !this.isInitialLoad) {
        // Only scroll into view if not on initial load
        button.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    });
  }

  handleNavClick(event) {
    event.preventDefault();
    const targetId = event.currentTarget.getAttribute('data-target');
    const targetElement = document.querySelector(targetId);
    
    if (targetElement) {
      this.scrollToTarget(targetElement);
      this.navLinks.forEach(button => {
        const isActive = button === event.currentTarget;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive);
      });
    }
  }

  scrollToTarget(targetElement) {
    const elementPosition = targetElement.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - this.headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
}

// Initialize the navigation when the DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.collection-nav')) {
    new CollectionNavigation();
  }
});